export default "__VITE_ASSET__CmPxcgIc__"